import $ from 'jquery';

$(document).ready(function () {
  twoThirdsTextBlock();
});
function twoThirdsTextBlock() {
  $('.js-acf-two-thirds-text-block').each(function () {});
}
